import { Utils } from 'core/utils';

export class QualityRating
{
  public static readonly Q1: number = 1;
  public static readonly Q2: number = 2;
  public static readonly Q3: number = 3;
  public static readonly Q4: number = 4;
  public static readonly Q5: number = 5;

  public static getQualityByPercent(qualityInPercent: number): number
  {
    if (qualityInPercent >= 0.28) {
      return QualityRating.Q5;
    }
    else if (qualityInPercent >= 0.25) {
      return QualityRating.Q4;
    }
    else if (qualityInPercent >= 0.17) {
      return QualityRating.Q3;
    }
    else if (qualityInPercent >= 0.1) {
      return QualityRating.Q2;
    }
    else {
      return QualityRating.Q1;
    }
  }

  public static getQualityString(qualityRating: number): string
  {
    switch (qualityRating) {
      case QualityRating.Q5:
      case QualityRating.Q4:
        return 'good';
      case QualityRating.Q3:
        return 'medium';
      default:
        return 'bad';
    }
  }

  public static getQualityImageUrl(qualityRating: number): string
  {
    switch (qualityRating) {
      case QualityRating.Q5:
      case QualityRating.Q4:
        return Utils.url('./assets/img/image-quality-rating/quality-good.svg');
      case QualityRating.Q3:
        return Utils.url(
            './assets/img/image-quality-rating/quality-medium.svg');
      default:
        return Utils.url('./assets/img/image-quality-rating/quality-bad.svg');
    }
  }
}
